export const WEB_CART_FLOW_KEYS = {
    IS_FROM_WEB_CART: "isFromWebCart",
    IS_FROM_GIFTING_CART: "isFromGiftingCart",
    IS_FROM_MRO_FOOD_CART: "isFromMROFoodCart",
    IS_FROM_QUICK_CHECKOUT: "isFromQuickCheckout",
};

export const checkIfUserIsViaAnyCartFlow = () => {
    return Object.values(WEB_CART_FLOW_KEYS).some((key) => sessionStorage.getItem(key) === "true");
};

export const isWebCartFlow = () => {
    const isSessionStorageAvailable = typeof window !== "undefined" && typeof sessionStorage !== "undefined";
    return isSessionStorageAvailable && checkIfUserIsViaAnyCartFlow();
};
